<template>
  <EntityContainer
    containerId="cabinet-invitations"
    :questionText="$t(questionText)"
    questionId="question"
    :question="$t(question)"
  >
    <EntityNavBar
      :show-search="false"
      :show-add-button="false"
      :heading="$t('invitations')"
    />
    <BaseTabs
      v-model="personalSettings"
      small
      style="margin-bottom: 48px"
      class="mt-20"
      :tabs="[
        {
          text: $t('name.counterparties'),
          value: 'counterparties',
          link: 'invitation.counterparties',
        },
        {
          text: $t('name.contracts'),
          value: 'contracts',
          link: 'invitation.contracts',
        },
      ]"
    />
    <slot />
  </EntityContainer>
</template>

<script>
import EntityNavBar from "~/components/Common/EntityNavBar.vue";
import EntityContainer from "~/components/Common/EntityContainer.vue";

export default {
  name: "BaseInvitation",
  components: { EntityNavBar,
    EntityContainer},
  props: {
    questionText: String,
    question: String,
  },
  data() {
    return {
      personalSettings: "contracts"
    };
  },
  computed: {
    containerClass: function() {
      return this.personalSettings;
    }
  }
};
</script>
